import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';

// import List from 'antd/lib/list';
// import Avatar from 'antd/lib/avatar';
// import Button from 'antd/lib/button';

import Admin from 'hive-admin';
import Form from 'hive-admin/src/components/Form';
import Field from 'hive-admin/src/components/Field';
// eslint-disable-next-line max-len
import FieldConnectionSelect from 'hive-admin/src/components/FieldConnectionSelect';
import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

import { Currency } from '../../../components/SystemCountry';

import Types from '../../../modules/types';

import { createField as createSectionsField } from '../../../modules/sections';
import AdminComponent from '../../../components/Admin';
import {
  activityNotCreate,
  activityNotEdit,
  productStoreInternal,
  productTypeNotMerchant,
  productTypeNotReferral,
  productTypeNotReseller,
  productTypeNotMerchantNorReseller,
  productKindIsAbstract,
  productKindNotAbstract,
  productUnlockOnPurchaseNotEnabled,
} from './helpers';

import { getProductsUrl } from '../../../helpers/getStoreUrl';
import getFilterWithCol from '../../../helpers/getFilterWithCol';
import {
  fieldI18nLanguage,
  getI18nFields,
} from '../../../helpers/i18n';
import createSlug from '../../../helpers/createSlug';

import tests from '../../../helpers/tests';

// eslint-disable-next-line max-len
import { createFieldsRegister } from '../../../components/ActionPopulateFieldsFromTarget';

import { createChangeLogSection } from '../../../components/FieldChangeLog';

import {
  FIELDS_VARIATION_DEFAULT,
  fieldVariations,
} from './variation';

import generateSkuFields from './generate-sku';

// function FieldTextComponent({ value, disabled, ...props }) {
//   return (
//     <Input
//       {...props}
//       disabled={disabled}
//       value={disabled ? 'Store Default' : value}
//     />
//   );
// }
 // eslint-disable-next-line max-len
const { viewerIsNotAdmin, viewerIsAdminAndDoesNotHavePermissionToEditProducts } = tests;

const compiledViewerIsNotAdmin = Admin.compileFromLibrary(viewerIsNotAdmin);

const {
  fields: POPULATE_ORIGINAL_PRODUCT_FIELDS,
  add: addToPopulateOriginalProductFields,
} = createFieldsRegister();

const ResellerChoiceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 5px;
  /* border-bottom: 1px solid ${({ theme }) => theme.less.borderColor}; */
  /* margin-top: 10px; */
`;

const ResellerChoiceImage = styled.div`
  width: 100px;
  height: 100px;
  /* background: red; */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("${({ src }) => src}");
  flex-shrink: 0;
`;

const ResellerChoiceInfo = styled.div`
  display: flex;
  flex: 1;
  flex-grow: 1;
  min-height: 100px;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const ResellerChoiceInfoSection = styled.div`
  width: 100%;
`;

const ResellerChoiceInfoLink = styled.a`
  padding-left: 10px;
  margin-left: 10px;
  border-left: 1px solid ${({ theme }) => theme.less.borderColor};
`;

const GalleryItemWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const GalleryItemFieldWrapper = styled.div`
  display: flex;
  .ant-row.ant-form-item {
    padding-bottom: 0px;
    margin-bottom: 0px;
  }
  &[data-gallery-field-name="image"] {
    [data-input-name="image"] {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .ant-upload-select-picture-card {
      margin-right: 0px;
      margin-bottom: 0px;
    }
    .ant-upload-list-picture-card-container {
      margin: 0px;
    }
    .ant-upload-list-picture-card .ant-upload-list-item {
      margin: 0px;
    }
  }
  &[data-gallery-field-name="skus"] {
    width: 100%;
    .ant-select-selection {
      height: 103px;
    }
    [data-input-name="skus"] {
      padding-right: 0px !important;
    }
  }
`;

function createGetAnnotation(fieldName) {
  return (initialAnnotation, { form }) => {
    if (form) {
      const count = form.getFieldValue(fieldName)?.length || 0;
      if (count > 0) {
        return `/ ${count} ${count === 1 ? 'Item' : 'Items'}`;
      }
    }
    return null;
  };
}

export const fieldsImages = [
  addToPopulateOriginalProductFields(['FieldUploadRefs', {
    name: 'image',
    label: 'Image',
    // rules: [['validation.isRequired']],
    accept: 'image/jpg,image/jpeg,image/png,image/webp',
    col: 1,
    transformations: [
      ['GM', { command: 'compress', maxWidth: 1500 }],
      ['GM', { command: 'webp' }],
    ],
  }], 'Image'),
  ['Divider', { name: 'imageDividerAfter', skip: [] }],
];

export const fieldsStore = [
  getFilterWithCol(['FieldConnectionSelect', {
    name: 'store',
    placeholder: 'Select the product store',
    url: '/stores/list',
    searchPaths: ['name'],
    rules: [['validation.isRequired']],
    disabled: [activityNotCreate],
    virtual: [activityNotCreate],
    skip: [viewerIsNotAdmin],
    renderChoice: (choice, field, props) => {
      const render = FieldConnectionSelect.config.renderChoice(
        choice,
        field,
        props,
      );
      return React.cloneElement(
        render,
        {
          onClick: () => {
            if (props.form) {
              props.form.setFieldsValue({
                type: Types.STORE_TYPE_TO_STORE_PRODUCT_TYPE_MAP[
                  choice.data.type
                ],
                storeData: choice.data,
                referralStore: undefined,
                referralProduct: undefined,
                originStore: undefined,
                originProduct: undefined,
              });
            }
          },
        },
      );
    },
  }], 12),
  ['FieldHidden', {
    name: 'storeData',
    virtual: [() => true],
  }],
];

export const fieldsType = [
  ['FieldSelect', {
    name: 'type',
    placeholder: 'Type',
    getInitialValue: (fieldConfig, formProps) => {
      const { viewer } = formProps;
      if (viewer && viewer.role === 'SELLER') {
        const value = Types.STORE_TYPE_TO_STORE_PRODUCT_TYPE_MAP[
          viewer.storeType
        ];
        if (value) {
          return value;
        }
      }
      return Field.config.getInitialValue(fieldConfig, formProps);
    },
    formItemConfig: { style: { display: 'none' } },
    rules: [['validation.isRequired']],
    hidden: [() => true],
    disabled: [() => true],
    virtual: [activityNotCreate],
    choices: Types.STORE_PRODUCT_TYPE.map(storeType => ({
      label: Types.STORE_PRODUCT_TYPE_LABELS_MAP[storeType],
      value: storeType,
    })),
  }],
  ['FieldSelect', {
    name: 'kind',
    placeholder: 'Kind',
    block: true,
    choices: Types.PRODUCT_KIND_LIST.map(({ id, label }) => ({
      value: id,
      label,
    })),
    initialValue: Types.PRODUCT_KIND[0],
    rules: [['validation.isRequired']],
    virtual: [activityNotCreate],
    disabled: [activityNotCreate],
    getCol: (fieldConfig, props) => {
      const viewerIsNotAdminResult = compiledViewerIsNotAdmin(props);
      const col = viewerIsNotAdminResult ? 24 : 12;
      return {
        xs: { span: 24 },
        lg: { span: col },
      };
    },
  }],
];

export const fieldsMeta = [
  // fieldFavicon,
  ['FieldText', {
    name: 'metaTitle',
    label: 'Title',
  }],
  ['FieldText', {
    name: 'metaDescription',
    label: 'Description',
  }],
  ['FieldText', {
    name: 'metaKeywordsString',
    label: 'Keywords',
  }],
].map(field => AdminComponent.compileFromLibrary([field[0], {
  ...field[1],
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_social_meta',
  ]],
}]));

// const action = Admin.compileFromLibrary(['ActionWithRequest', {
//   name: 'referralPopulate',
//   // title: 'Populate with referral product fields',
//   title: null,
//   icon: 'download',
//   ghost: true,
//   shape: 'circle',
//   size: 'small',
//   virtual: [() => true],
//   popconfirm: {
//     title: (
//       <div>
//         <p>
//           <AntCheckbox size="small" />
//           &nbsp;
//           Name
//         </p>
//         <p>
//           <AntCheckbox size="small" />
//           &nbsp;
//           Link
//         </p>
//       </div>
//     ),
//   },
//   skip: [
//     productTypeNotReferral,
//     [
//       'condition.testFieldValue',
//       'referralProduct',
//       '==',
//       undefined,
//     ],
//   ],
//   getRequestConfig: props => ({
//     url: `products/${props.form.getFieldValue('referralProduct')}`,
//     method: 'get',
//   }),
//   handleSuccess: (data, props) => {
//     props.form.setFieldsValue({
//       name: data.name,
//       slug: data.slig,
//       tagline: data.tagline,
//       image: data.image,
//       imageSizing: data.imageSizing,
//       gallery: data.gallery,
//       galleryimageSizing: data.galleryimageSizing,
//     });
//   },
// }]);

export const fieldsRest = [
  addToPopulateOriginalProductFields(getFilterWithCol(['FieldText', {
    name: 'name',
    // eslint-disable-next-line arrow-body-style
    // label: (props, field) => {
    //   return (
    //     <span>
    //       {field.name}
    //       {action.render(props)}
    //     </span>
    //   );
    // },
    placeholder: 'Product name',
    rules: [['validation.isRequired']],
    i18nTranslatable: true,
    // eslint-disable-next-line max-len
    prepareValueForForm: (value, props) => {
      if (props.activity === 'create') {
        let i18nLanguageValue = null;
        const form = (
            props.forms
          ? props.forms[props.forms.length - 1]
          : props.form
        );
        if (form && form.getFieldValue) {
          i18nLanguageValue = form.getFieldValue('i18nLanguage') || 'en';
        } else {
          i18nLanguageValue = 'en';
        }
        if (i18nLanguageValue === 'en') {
          props.form.setFieldsValue({ slug: createSlug(value?.target?.value) });
        }
      }
      return value;
    },
  }], 24)),
  addToPopulateOriginalProductFields(getFilterWithCol(['FieldSlug', {
    name: 'slug',
    rules: [['validation.isRequired']],
    copyLinkSegments: [
      (props) => {
        if (props.data && props.data.storeData) {
          return getProductsUrl(props.data.storeData);
        }
        return null;
      },
    ],
  }], 12)),
  getFilterWithCol(['FieldDatePicker', {
    name: 'publishedAt',
    // label: `${getTranslation('date')}:`,
    allowClear: false,
    label: 'Published Date',
    prepareValueForInput: (
      value => (value ? moment(value) : moment()
    )),
    format: ['DD.MM.YYYY. HH:mm'],
    showTime: {
      // disabledMinutes: () => new Array(59).fill(0).map((n, i) => ++i),
      disabledSeconds: () => new Array(60).fill(0).map((n, i) => i + 1),
      // minuteStep: 15,
      hideDisabledOptions: true,
    },
    getInitialValue: (fieldConfig, formProps) => {
      if (formProps.activity === 'create') {
        return undefined;
      }
      return Field.config.getInitialValue(fieldConfig, formProps);
    },
  }], 12),
  addToPopulateOriginalProductFields(['FieldTextArea', {
    name: 'tagline',
    label: 'Description',
    autoSize: {
      minRows: 2,
      maxRows: 6,
    },
    placeholder: 'Product Description',
    sendEmpty: true,
    i18nTranslatable: true,
  }]),
  getFilterWithCol(['FieldConnectionSelect', {
    name: 'category',
    placeholder: 'Select a product category',
    url: '/categories',
    getExtraQueryConditions: (props) => {
      if (!props.viewer) {
        return [];
      }
      if (props.viewer.role === 'SELLER') {
        return [{ store: props.viewer.store }];
      }
      const store = props.form.getFieldValue('store');
      return store
      ? [{ store }]
      : [{ name: '______________' }];
    },
    searchPaths: ['name'],
    rules: [['validation.isRequired']],
    handleChange: (value, props) => {
      if (value !== props.value) {
        props.form.setFieldsValue({
          subcategory: null,
        });
      }
    },
    // getFieldsToResetOnChange: (props, value) => ['subcategory'],
  }], 12),
  getFilterWithCol(['FieldConnectionSelect', {
    name: 'subcategory',
    placeholder: 'Select a product subcategory',
    url: '/categories/:id/subcategories',
    // getExtraQueryConditions: (props) => {
    //   if (!props.viewer) {
    //     return [];
    //   }
    //   if (props.viewer.role === 'SELLER') {
    //     return [{ store: props.viewer.store }];
    //   }
    //   const store = props.form.getFieldValue('store');
    //   return store
    //   ? [{ store }]
    //   : [{ name: '______________' }];
    // },
    extractChoicesQuery: (search, props) => ({
      id: props.form.getFieldValue('category'),
      search,
    }),
    extractValueQuery: (value, props) => ({
      id: props.form.getFieldValue('category'),
      subcategoryId: value,
    }),
    searchPaths: ['name'],
  }], 12),
  getFilterWithCol(['FieldConnectionSelect', {
    name: 'categories',
    label: 'Additional Categories',
    placeholder: 'Select additional product categories',
    mode: 'multiple',
    url: '/categories',
    getExtraQueryConditions: (props) => {
      if (!props.viewer) {
        return [];
      }
      if (props.viewer.role === 'SELLER') {
        return [{ store: props.viewer.store }];
      }
      const store = props.form.getFieldValue('store');
      return store
      ? [{ store }]
      : [{ name: '______________' }];
    },
    searchPaths: ['name'],
  }], 24),
  getFilterWithCol(['FieldConnectionSelect', {
    name: 'collections',
    label: 'Collections',
    placeholder: 'Select product collections',
    mode: 'multiple',
    url: '/collections',
    getExtraQueryConditions: (props) => {
      if (!props.viewer) {
        return [];
      }
      if (props.viewer.role === 'SELLER') {
        return [{ store: props.viewer.store }];
      }
      const store = props.form.getFieldValue('store');
      return store
        ? [{ store }]
        : [{ name: '______________' }];
    },
    searchPaths: ['name'],
  }], 24),
  ['FieldSelect', {
    name: 'attributes',
    label: 'Shipping Disclaimers',
    mode: 'multiple',
    skip: [productTypeNotMerchant],
    placeholder: 'eg. product is Flammable, also Fragile',
    hidden: [
      viewerIsNotAdmin,
      productKindIsAbstract,
    ],
    virtual: [
      viewerIsNotAdmin,
      productKindIsAbstract,
    ],
    allowClear: true,
    choices: Types.PRODUCT_ATTRIBUTE_ITEMS.map(({ id, label }) => ({
      value: id,
      label,
    })),
  }],
  ['FieldConnectionSelect', {
    name: 'relatedProducts',
    label: 'Related Products',
    placeholder: 'Link products related to this one.',
    url: '/products',
    mode: 'multiple',
    searchPaths: ['name', 'variations.storeSku'],
    getExtraQueryConditions: (props) => {
      if (!props.viewer) {
        return [];
      }
      if (props.viewer.role === 'SELLER') {
        return [{ store: props.viewer.store }];
      }
      const { _id } = props.data || {};
      const store = props.form.getFieldValue('store');
      return store
      ? [{ store, _id: _id ? { NE: _id } : undefined }]
      : [{ name: '______________' }];
    },
  }],
  addToPopulateOriginalProductFields(getFilterWithCol(['FieldRadio', {
    name: 'imageSizing',
    label: 'Thumbnail Image Sizing',
    choices: (
      Types.IMAGE_SIZING_PRODUCT
      .map(value => ({
        label: Types.IMAGE_SIZING_PRODUCT_LABELS_MAP[value],
        value,
      }))
    ),
    rules: [['validation.isRequired']],
    initialValue: Types.IMAGE_SIZING_PRODUCT[1],
    hidden: [() => true],
    block: true,
  }], 12)),
  addToPopulateOriginalProductFields(getFilterWithCol(['FieldRadio', {
    name: 'galleryimageSizing',
    label: 'Gallery Image Sizing',
    choices: (
      Types.IMAGE_SIZING_PRODUCT
      .map(value => ({
        label: Types.IMAGE_SIZING_PRODUCT_LABELS_MAP[value],
        value,
      }))
    ),
    rules: [['validation.isRequired']],
    initialValue: Types.IMAGE_SIZING_PRODUCT[0],
    hidden: [() => true],
    block: true,
  }], 12)),
  ['FieldRadio', {
    name: 'unlockOnPurchase.enabled',
    label: 'Unlock On Purchase',
    choices: [
      { value: true, label: 'Enabled' },
      { value: false, label: 'Disabled' },
    ],
    // rules: [['validation.isRequired']],
    skip: [productKindNotAbstract],
    initialValue: false,
  }],
  getFilterWithCol(['FieldText', {
    name: 'unlockOnPurchase.actionLabel',
    label: 'Unlocked Action Label',
    skip: [
      productKindNotAbstract,
      productUnlockOnPurchaseNotEnabled,
    ],
    i18nTranslatable: true,
  }], 12),
  getFilterWithCol(['FieldText', {
    name: 'unlockOnPurchase.actionLink',
    label: 'Unlocked Action Link',
    skip: [
      productKindNotAbstract,
      productUnlockOnPurchaseNotEnabled,
    ],
  }], 12),
  ['FieldTextArea', {
    name: 'unlockOnPurchase.description',
    label: 'Unlocked Description',
    autoSize: { minRows: 2 },
    skip: [
      productKindNotAbstract,
      productUnlockOnPurchaseNotEnabled,
    ],
    i18nTranslatable: true,
  }],

  //
  // Referral targets
  //

  ['Divider', {
    name: 'referralAndResellerDivider',
    skip: [
      productTypeNotMerchantNorReseller,
    ],
  }],
  ['FieldConnectionSelect', {
    name: 'referralStore',
    label: 'Target Store',
    placeholder: 'Store you have a deal with',
    url: '/stores/referral',
    searchPaths: ['name'],
    rules: [['validation.isRequired']],
    disabled: [activityNotCreate],
    virtual: [activityNotCreate],
    skip: [productTypeNotReferral],
    getExtraQueryProps: (props) => {
      const value = (props.viewer && props.viewer.role === 'SELLER')
      ? props.viewer.store
      : props.form
      ? props.form.getFieldValue('store')
      : null;
      if (value) {
        return { store: value };
      }
      return {};
    },
    renderChoice: (choice, field, props) => {
      const render = FieldConnectionSelect.config.renderChoice(
        choice,
        field,
        props,
      );
      return React.cloneElement(
        render,
        {
          onClick: () => {
            if (props.form) {
              props.form.setFieldsValue({
                referralProduct: undefined,
              });
            }
          },
        },
      );
    },
  }],
  ['FieldConnectionSelect', {
    name: 'referralProduct',
    label: 'Target Product',
    placeholder: 'Product you will be promoting',
    url: '/products',
    searchPaths: ['name', 'variations.storeSku'],
    rules: [['validation.isRequired']],
    disabled: [activityNotCreate],
    virtual: [activityNotCreate],
    skip: [
      productTypeNotReferral,
      [
        'condition.testFieldValue',
        'referralStore',
        '==',
        undefined,
      ],
    ],
    getExtraQueryConditions: (props) => {
      const targetStore = props.form
      ? props.form.getFieldValue('referralStore')
      : null;
      if (targetStore && targetStore.length) {
        return [{ store: targetStore }];
      }
      return [];
    },
  }],
  ['ActionPopulateFieldsFromTarget', {
    name: 'referralPopulate',
    title: 'Get fields from target product',
    targetFieldName: 'referralProduct',
    targetUrlPrefix: 'products',
    targetFields: POPULATE_ORIGINAL_PRODUCT_FIELDS,
    ghost: true,
    skip: [
      productTypeNotReferral,
      [
        'condition.testFieldValue',
        'referralProduct',
        '==',
        undefined,
      ],
    ],
  }],
  ['FieldConnectionSelect', {
    name: 'originProduct',
    label: 'Target Product',
    placeholder: 'Product you will be reselling',
    url: '/products',
    searchPaths: ['name', 'variations.storeSku'],
    rules: [['validation.isRequired']],
    disabled: [activityNotCreate],
    virtual: [activityNotCreate],
    skip: [productTypeNotReseller],
    extractChoicesQuery: (search, props) => {
      const query = FieldConnectionSelect.config.extractChoicesQuery(
        search,
        props,
      );
      query.where = query.where || {};
      query.where.AND = query.where.AND || [];
      query.where.AND.push({
        'stockAggregates.WAREHOUSE': { GTE: 1 },
      });
      return query;
    },
    // eslint-disable-next-line no-unused-vars
    getExtraQueryProps: props => ({
      populate: {
        store: true,
      },
    }),
    // eslint-disable-next-line no-unused-vars
    getExtraQueryConditions: props => [{
      resellerEnrolled: true,
    }],
    // eslint-disable-next-line no-unused-vars
    getChoiceLabel: (choice, field, props) => (
      <span>
        <b>{choice.data.name}</b>
        {` by ${choice.data.store.name}`}
      </span>
    ),
    // eslint-disable-next-line no-unused-vars
    renderChoiceLabel: (choice, field, props) => (
      <ResellerChoiceWrapper>
        <ResellerChoiceImage
          src={choice.data.image.src}
        />
        <ResellerChoiceInfo>
          <ResellerChoiceInfoSection>
            <b>{choice.data.name}</b>
            <br />
            {`by ${choice.data.store.name}`}
          </ResellerChoiceInfoSection>
          <ResellerChoiceInfoSection>
            <Currency
              suffix={` ${
                choice.data.priceLowest === choice.data.priceHighest
                ? Types.decimalize(choice.data.priceLowest)
                : `${
                    Types.decimalize(choice.data.priceLowest)
                  } - ${
                    Types.decimalize(choice.data.priceHighest)
                  }`
              }`}
            />
            {` at ${choice.data.resellerCommissionPercentage}%`}
            <ResellerChoiceInfoLink
              href={`${process.env.REACT_APP_PACKMAN_SHOP_URL}/${
                choice.data.store.slug
              }/${
                choice.data.slug
              }`}
              target="_blank"
              rel="noreferrer"
              style={{
                paddingLeft: '5px',
                marginLeft: '5px',
                borderLeft: '1px solid #ddd',
              }}
            >
              See in shop
            </ResellerChoiceInfoLink>
          </ResellerChoiceInfoSection>
        </ResellerChoiceInfo>
      </ResellerChoiceWrapper>
    ),
  }],
  ['ActionPopulateFieldsFromTarget', {
    name: 'resellerPopulate',
    title: 'Get fields from target product',
    targetFieldName: 'originProduct',
    targetUrlPrefix: 'products',
    targetFields: POPULATE_ORIGINAL_PRODUCT_FIELDS,
    ghost: true,
    skip: [
      productTypeNotReseller,
      [
        'condition.testFieldValue',
        'originProduct',
        '==',
        undefined,
      ],
    ],
  }],
  //
  // Reseller Program
  //

  ['Divider', {
    name: 'resellerConfigDivider',
    skip: [
      activityNotEdit,
      productStoreInternal,
      productTypeNotMerchantNorReseller,
    ],
  }],
  ['FieldSwitch', {
    name: 'featured',
    label: null,
    inlineLabelAfter: 'Featured',
    initialValue: false,
    rules: [['validation.isRequired']],
    col: { xs: 24, lg: 12 },
  }],
  ['FieldSwitch', {
    name: 'resellerEnrolled',
    label: null,
    inlineLabelAfter: 'Enroll for reseller program',
    skip: [
      activityNotEdit,
      productStoreInternal,
      productTypeNotMerchant,
      viewerIsNotAdmin,
    ],
    col: { xs: 24, lg: 12 },
  }],
  ['FieldText', {
    name: 'resellerCommissionPercentage',
    label: null,
    align: 'right',
    addonBefore: 'Reseller Commission',
    type: 'number',
    // initialValue: 0,
    addonAfter: '%',
    skip: [
      activityNotEdit,
      productTypeNotMerchant,
      viewerIsNotAdmin,
      [
        'condition.testFieldValue',
        'resellerEnrolled',
        '!==',
        true,
      ],
    ],
    rules: [
      {
        validator: (rule, value, cb) => {
          if (
              !Number.isFinite(value)
            || value < Types.RESELLER_COMMISSION_PERCENTAGE_MIN
            || value > Types.RESELLER_COMMISSION_PERCENTAGE_MAX
          ) {
            cb(`Must be a number between ${
              Types.RESELLER_COMMISSION_PERCENTAGE_MIN
            } and ${
              Types.RESELLER_COMMISSION_PERCENTAGE_MAX
            }`);
            return undefined;
          }
          cb();
          return undefined;
        },
      },
    ],
  }],
  ['FieldText', {
    name: 'resellerAddedValuePercentage',
    label: 'Added Value',
    type: 'number',
    initialValue: 0,
    addonAfter: '%',
    skip: [productTypeNotReseller],
    rules: [
      {
        validator: (rule, value, cb) => {
          if (
              !Number.isFinite(value)
            || value < Types.RESELLER_ADDED_VALUE_PERCENTAGE_MIN
            || value > Types.RESELLER_ADDED_VALUE_PERCENTAGE_MAX
          ) {
            cb(`Must be a number between ${
              Types.RESELLER_ADDED_VALUE_PERCENTAGE_MIN
            } and ${
              Types.RESELLER_ADDED_VALUE_PERCENTAGE_MAX
            }`);
            return undefined;
          }
          cb();
          return undefined;
        },
      },
    ],
  }],

  //
  // Variation Defaults
  //

  ['FieldTitle', {
    title: 'Details',
    skip: [productTypeNotMerchant],
  }],
  ...FIELDS_VARIATION_DEFAULT,

  //
  // Variants
  //

  // ['FieldHidden', {
  //   name: 'useVariants',
  //   initialValue: true,
  //   skip: [productTypeNotMerchant],
  // }],
  asLocalStorageField(['FieldTitleToggle', {
    title: 'Variants',
    name: 'showVariants',
    initialValue: false,
    getAnnotation: createGetAnnotation('variants'),
    // getTitle: (title, props) => {
    //   const useVariants = props.form.getFieldValue('useVariants');
    //   return (
    //     <>
    //       Variants
    //       &nbsp;
    //       <AntdSwitch
    //         checked={!!useVariants}
    //         onChange={(newChecked) => {
    //           props.form.setFieldsValue({
    //             useVariants: !!newChecked,
    //           });
    //         }}
    //       />
    //     </>
    //   );
    // },
    // eslint-disable-next-line max-len
    // subtitle: 'Options which map to separate SKUs, creating their own stock and price.',
    subtitle: (
      <>
        Separate product into multiple choices, each having their own
        SKU, stock level and price.
      </>
    ),
    skip: [productTypeNotMerchant],
  }]),
  ['FieldSortableList', {
    name: 'variants',
    skip: [
      productTypeNotMerchant,
    ],
    hidden: [
      ['condition.fieldIsNotTrue', 'showVariants'],
    ],
    label: null,
    supportDuplicate: true,
    addButtonLabel: 'Add Variant',
    condensed: true,
    getItemFields: getI18nFields,
    fields: [
      getFilterWithCol(['FieldText', {
        name: 'label',
        label: null,
        prefix: 'Label:',
        // col: { xs: { span: 24 }, lg: { span: 8 } },
        i18nTranslatable: true,
      }], 12),
      getFilterWithCol(['FieldSelect', {
        name: 'type',
        label: null,
        prefix: 'Type:',
        initialValue: 'CHOICE',
        choices: ['Choice', 'Color', 'Image'].map(label => ({
          value: label.toUpperCase(),
          label,
        })),
      }], 12),
      ['FieldSortableList', {
        name: 'choices',
        label: null,
        addButtonLabel: 'Add Variant Choice',
        getItemFields: getI18nFields,
        condensed: true,
        // head: 'horizontal',
        shouldRenderPlaceholder: true,
        sortableInputWrapperStyle: { marginTop: '5px' },
        fields: [
          ['FieldText', {
            name: 'label',
            label: null,
            prefix: 'Label:',
            col: { span: 24 },
            i18nTranslatable: true,
          }],
          ['FieldColorPicker', {
            name: 'color',
            label: null,
            prefix: 'Color:',
            hidden: [props => props.forms[0].getFieldValue('type') !== 'COLOR'],
          }],
          ['FieldUploadRefsHorizontal', {
            name: 'image',
            label: null,
            maxCount: 1,
            listType: 'picture-small',
            uploadLabel: 'Upload Image',
            // rules: [['validation.isRequired']],
            accept: 'image/jpg,image/jpeg,image/png,image/webp',
            transformations: [
              ['GM', { command: 'compress', maxWidth: 2000 }],
              ['GM', { command: 'webp' }],
            ],
            hidden: [props => props.forms[0].getFieldValue('type') !== 'IMAGE'],
          }],
        ],
      }],
    ],
  }],

  //
  // Options
  //

  asLocalStorageField(['FieldTitleToggle', {
    title: 'Options',
    name: 'showOptions',
    initialValue: false,
    getAnnotation: createGetAnnotation('options'),
    // eslint-disable-next-line max-len
    // subtitle: 'Options which further describe the product and do not keep separate stock or affect the price.',
    subtitle: (
      <>
        Enable customers to further describe existing product choices.
      </>
    ),
    skip: [productTypeNotMerchant],
  }]),
  ['FieldSortableList', {
    name: 'options',
    skip: [productTypeNotMerchant],
    hidden: [
      ['condition.fieldIsNotTrue', 'showOptions'],
    ],
    label: null,
    supportDuplicate: true,
    addButtonLabel: 'Add Option',
    condensed: true,
    getItemFields: getI18nFields,
    fields: [
      getFilterWithCol(['FieldText', {
        name: 'label',
        label: null,
        prefix: 'Label:',
        // col: { xs: { span: 24 }, lg: { span: 8 } },
        i18nTranslatable: true,
      }], 12),
      getFilterWithCol(['FieldSelect', {
        name: 'type',
        label: null,
        prefix: 'Type:',
        choices: Types.PRODUCT_OPTION_TYPE_LIST.map(item => ({
          value: item.id,
          label: item.label,
        })),
        initialValue: Types.PRODUCT_OPTION_TYPE[0],
      }], 12),
      ['FieldText', {
        name: 'placeholder',
        label: null,
        prefix: 'Placeholder:',
        skip: [
          [
            'condition.testFieldValue',
            'type',
            '!==',
            'TEXT',
          ],
        ],
        i18nTranslatable: true,
      }],
      ['FieldSortableList', {
        name: 'choices',
        label: null,
        addButtonLabel: 'Add Option Choice',
        getItemFields: getI18nFields,
        condensed: true,
        // head: 'horizontal',
        shouldRenderPlaceholder: true,
        hidden: [
          [
            'condition.testFieldValue',
            'type',
            '===',
            'TEXT',
          ],
        ],
        sortableInputWrapperStyle: { marginTop: '5px' },
        fields: [
          ['FieldText', {
            name: 'label',
            label: null,
            prefix: 'Label:',
            col: { span: 24 },
            i18nTranslatable: true,
          }],
          ['FieldColorPicker', {
            name: 'color',
            label: null,
            prefix: 'Color:',
            hidden: [props => props.forms[0].getFieldValue('type') !== 'COLOR'],
          }],
          ['FieldUploadRefsHorizontal', {
            name: 'image',
            label: null,
            maxCount: 1,
            listType: 'picture-small',
            uploadLabel: 'Upload Image',
            // rules: [['validation.isRequired']],
            accept: 'image/jpg,image/jpeg,image/png,image/webp',
            transformations: [
              ['GM', { command: 'compress', maxWidth: 2000 }],
              ['GM', { command: 'webp' }],
            ],
            hidden: [props => props.forms[0].getFieldValue('type') !== 'IMAGE'],
          }],
        ],
      }],
    ],
  }],

  //
  // Variations
  //

  asLocalStorageField(['FieldTitleToggle', {
    title: 'SKUs',
    subtitle: (
      <>
        Final product options available for purchase, each with it&apos;s own
        SKU, price, and inventory management.
      </>
    ),
    getAnnotation: createGetAnnotation('variations'),
    name: 'showVariations',
    initialValue: true,
    skip: [productTypeNotMerchant],
  }]),
  ...generateSkuFields,
  fieldVariations,

  AdminComponent.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_social_meta',
    initialValue: false,
    title: 'SEO Meta',
    // size: 'medium',
    subtitle: 'Setup your store seo meta',
    skip: [],
  }])),
  ...fieldsMeta,

  //
  // Gallery
  //

  asLocalStorageField(['FieldTitleToggle', {
    name: 'showGallery',
    title: 'Gallery',
    getAnnotation: createGetAnnotation('gallery'),
    subtitle: (
      <>
        Extra product visuals displayed after the main product image.
      </>
    ),
    initialValue: false,
    skip: [],
  }]),
  // addToPopulateOriginalProductFields(['FieldUploadRefs', {
  //   name: 'gallery',
  //   label: 'Gallery',
  //   maxCount: 10,
  //   // rules: [['validation.isRequired']],
  //   accept: 'image/jpg,image/jpeg,image/png,image/webp',
  //   transformations: [
  //     ['GM', { command: 'compress', maxWidth: 2000 }],
  //   ],
  // }]),
  addToPopulateOriginalProductFields(['FieldSortableList', {
    name: 'gallery',
    // label: 'Gallery',
    label: null,
    addButtonLabel: 'Add Gallery Item',
    // eslint-disable-next-line max-len
    hidden: [
      ['condition.fieldIsNotTrue', 'showGallery'],
    ],
    // eslint-disable-next-line max-len
    // supportRemove: tests.viewerIsAdminAndDoesNotHavePermissionToEditProductsOtherCases,
    FormComponent: class GalleryItemForm extends Form {
      renderField(field, style = {}) {
        return (
          <GalleryItemFieldWrapper
            key={field.name}
            data-gallery-field-name={field.name}
            style={style}
          >
            {super.renderField(field)}
          </GalleryItemFieldWrapper>
        );
      }

      // eslint-disable-next-line no-unused-vars
      renderFields(fields) {
        const { fieldsMap } = this.state.props;
        return (
          <GalleryItemWrapper key="itemFields">
            {this.renderField(fieldsMap.image, {
            })}
            {this.renderField(fieldsMap.skus, {
            })}
          </GalleryItemWrapper>
        );
      }
    },
    condensed: true,
    fields: [
      ['FieldUploadRefs', {
        name: 'image',
        label: null,
        maxCount: 1,
        listType: 'picture-card',
        uploadLabel: 'Upload',
        // rules: [['validation.isRequired']],
        accept: (
          'image/jpg,image/jpeg,image/png,image/webp,video/mp4,video/webm'
        ),
        // eslint-disable-next-line max-len
        // skip: [viewerIsAdminAndDoesNotHavePermissionToEditProducts('forceProductsEditAndDeletion')],
        transformations: [
          ['GM', { command: 'compress', maxWidth: 1500 }],
          ['GM', { command: 'webp' }],
        ],
      }],
      ['FieldSelect', {
        name: 'skus',
        label: null,
        placeholder: 'SKUs',
        mode: 'multiple',
        choices: [],
        hidden: [
          // eslint-disable-next-line max-len
          //  tests.viewerIsAdminAndDoesNotHavePermissionToEditProductsOtherCases,
          // props => {
          //   console.log(props.datas[0].storeData, 'xxx');
          //   return false;
          // },
        ],
        renderChoices: (field, props) => {
          const form = props.forms[props.forms.length - 1];
          const data = props.datas[props.datas.length - 1];
          const variations = (
            form?.getFieldValue('variations')
            || data?.variations
            || []
          );
          return variations.reduce(
            (agr, choice) => {
              if (choice.storeSku) {
                agr.push(props.renderChoice({
                  value: choice.storeSku,
                  label: (
                    choice.name
                      ? `${choice.name} (${choice.storeSku})`
                      : choice.storeSku
                  ),
                }, field, props));
              }
              return agr;
            },
            [],
          );
        },
      }],
    ],
  }]),
  //
  // Augmented Reality
  //

  asLocalStorageField(['FieldTitleToggle', {
    name: 'showAugmentedRealityModels',
    title: 'Augmented Reality',
    getAnnotation: createGetAnnotation('augmentedRealityModels'),
    subtitle: (
      <>
        Augmented Reality files to be shown on mobile devices.
      </>
    ),
    initialValue: false,
    skip: [],
  }]),
  addToPopulateOriginalProductFields(['FieldSortableList', {
    name: 'augmentedRealityModels',
    label: null,
    addButtonLabel: 'Add Model',
    skip: [],
    hidden: [
      ['condition.fieldIsNotTrue', 'showAugmentedRealityModels'],
    ],
    condensed: true,
    shouldRenderPlaceholder: true,
    fields: [
      getFilterWithCol(['FieldUploadRefsHorizontal', {
        name: 'ios',
        label: null,
        maxCount: 1,
        listType: 'picture-small',
        uploadLabel: 'iOS (USDZ / Reality)',
        accept: 'file/usdz,file/reality',
      }], 12),
      getFilterWithCol(['FieldUploadRefsHorizontal', {
        name: 'android',
        label: null,
        maxCount: 1,
        listType: 'picture-small',
        uploadLabel: 'Android (GLTF / GLB)',
        accept: 'file/gltf,file/glb',
      }], 12),
      getFilterWithCol(['FieldSelect', {
        name: 'skus',
        label: null,
        placeholder: 'SKUs',
        mode: 'multiple',
        choices: [],
        renderChoices: (field, props) => {
          const form = props.forms[props.forms.length - 1];
          const data = props.datas[props.datas.length - 1];
          const variations = (
            form?.getFieldValue('variations')
            || data?.variations
            || []
          );
          return variations.reduce(
            (agr, choice) => {
              if (choice.storeSku) {
                agr.push(props.renderChoice({
                  value: choice.storeSku,
                  label: (
                    choice.name
                      ? `${choice.name} (${choice.storeSku})`
                      : choice.storeSku
                  ),
                }, field, props));
              }
              return agr;
            },
            [],
          );
        },
      }], 24),
    ],
  }]),

  //
  // Sections
  //

  asLocalStorageField(['FieldTitleToggle', {
    title: 'Sections',
    name: 'showSections',
    getAnnotation: createGetAnnotation('sections'),
    subtitle: 'Design your own custom product page with ease.',
    skip: [productTypeNotMerchantNorReseller],
  }]),
  createSectionsField('sections', {
    skip: [productTypeNotMerchantNorReseller],
    hidden: [
      ['condition.fieldIsNotTrue', 'showSections'],
    ],
    addButtonLabel: 'Add Section',
  }),
];

export const ADMIN = [
  fieldI18nLanguage,
  ...fieldsImages,
  ...fieldsStore,
  ...fieldsType,
  ...fieldsRest,
  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: props.data?.store,
        'target.type': 'Product',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];

export const SELLER = [
  fieldI18nLanguage,
  ...fieldsImages,
  ...fieldsStore,
  ...fieldsType,
  ...fieldsRest,
  ...fieldsMeta,
];
